module.exports = __webpack_public_path__ + "static/media/mute.28b89641.svg";